// extracted by mini-css-extract-plugin
module.exports = {"sortableSymbol":"SortableSymbol_sortableSymbol__tBP2v","alignRight":"SortableSymbol_alignRight__19p-k"};